import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of } from 'rxjs';
import * as timeBasedWorkPropositionActions from '../actions/time-based-work-proposition.actions';
import { TimeBasedWorkPropositionService } from '../../services/time-based-proposition.service';

@Injectable()
export class TimeBasedWorkPropositionEffects {
  constructor(
    private actions$: Actions,
    private timeBasedWorkPropositionService: TimeBasedWorkPropositionService
  ) {}

  // Load time-based work propositions
  loadTimeBasedWorkProposition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(timeBasedWorkPropositionActions.loadTimeBasedWorkProposition),
      mergeMap(({ ruleUid }) => {
        return this.timeBasedWorkPropositionService.getByRuleId(ruleUid!).pipe(
          map((timeBasedWorkProposition) => {
            return timeBasedWorkPropositionActions.loadTimeBasedWorkPropositionSuccess(
              {
                timeBasedWorkProposition,
              }
            );
          }),
          catchError((error) => {
            return of(
              timeBasedWorkPropositionActions.loadTimeBasedWorkPropositionFailure(
                { error }
              )
            );
          })
        );
      })
    )
  );

  // Delete multiple time-based work propositions
  deleteMultipleTimeBasedWorkPropositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        timeBasedWorkPropositionActions.deleteMultipleTimeBasedWorkPropositions
      ),
      mergeMap(({ uids }) => {
        return this.timeBasedWorkPropositionService
          .DeleteMultipleTimeBasedWorkPropositions(uids)
          .pipe(
            map(() =>
              timeBasedWorkPropositionActions.deleteMultipleTimeBasedWorkPropositionsSuccess(
                {
                  uids,
                }
              )
            ),
            catchError((error) =>
              of(
                timeBasedWorkPropositionActions.deleteMultipleTimeBasedWorkPropositionsFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );

  // Create multiple time-based work propositions
  createMultipleTimeBasedWorkPropositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        timeBasedWorkPropositionActions.createMultipleTimeBasedWorkPropositions
      ),
      mergeMap(({ requests }) => {
        return this.timeBasedWorkPropositionService
          .CreateMultipleTimeBasedWorkPropositions(requests)
          .pipe(
            map((timeBasedWorkPropositions) =>
              timeBasedWorkPropositionActions.createMultipleTimeBasedWorkPropositionsSuccess(
                {
                  timeBasedWorkPropositions,
                }
              )
            ),
            catchError((error) =>
              of(
                timeBasedWorkPropositionActions.createMultipleTimeBasedWorkPropositionsFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );

  // Update multiple time-based work propositions
  updateMultipleTimeBasedWorkPropositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        timeBasedWorkPropositionActions.updateMultipleTimeBasedWorkPropositions
      ),
      mergeMap(({ requests }) => {
        return this.timeBasedWorkPropositionService
          .UpdateMultipleTimeBasedWorkPropositions(requests)
          .pipe(
            map((timeBasedWorkPropositions) =>
              timeBasedWorkPropositionActions.updateMultipleTimeBasedWorkPropositionsSuccess(
                {
                  timeBasedWorkPropositions,
                }
              )
            ),
            catchError((error) =>
              of(
                timeBasedWorkPropositionActions.updateMultipleTimeBasedWorkPropositionsFailure(
                  {
                    error,
                  }
                )
              )
            )
          );
      })
    )
  );
}
